import React from "react";

export default function EmptyState() {
  return (
    <div className="text-center py-32 bg-white/40 dark:bg-slate-900/40 rounded-[40px] border-2 border-dashed border-slate-200 dark:border-slate-800">
      <div className="bg-white dark:bg-slate-800 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
        <i className="fas fa-clipboard-list text-indigo-500 text-2xl"></i>
      </div>
      <h2 className="text-xl font-bold text-slate-600 dark:text-slate-300">
        No tasks found.
      </h2>
      <p className="text-slate-400 text-sm mt-1 font-medium">
        Add a task or change your filters to get started.
      </p>
    </div>
  );
}
